const pillars = [
  {
    icon: "ri-leaf-line",
    title: "Eco-Friendly Products",
    titleAr: "منتجات صديقة للبيئة",
    text: "We carefully select sustainable, cruelty-free, and responsibly sourced products suitable for the Omani climate and skin.",
  },
  {
    icon: "ri-water-flash-line",
    title: "Water Conservation",
    titleAr: "الحفاظ على المياه",
    text: "Our salon implements smart water-saving systems to minimize consumption during all hair and spa services in Muscat.",
  },
  {
    icon: "ri-recycle-line",
    title: "Zero Waste Initiative",
    titleAr: "مبادرة النفايات الصفرية",
    text: "From recyclable packaging to biodegradable materials, Blue Moon Beauty is committed to protecting Oman's environment.",
  },
];

export default function SustainabilitySection() {
  return (
    <section className="py-16 sm:py-24 bg-[#f8f7f4]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-16 items-center">
          {/* Images */}
          <div className="grid grid-cols-2 gap-4 h-[300px] sm:h-[460px]">
            <div className="overflow-hidden h-full">
              <img
                src="https://public.readdy.ai/ai/img_res/77d01e225edbb8443beb518cb93fa03f.jpg"
                alt="Blue Moon Beauty Salon sustainability eco initiative Oman"
                className="w-full h-full object-cover object-top"
                loading="lazy"
              />
            </div>
            <div className="flex flex-col gap-4 h-full">
              <div className="overflow-hidden flex-1">
                <img
                  src="https://readdy.ai/api/search-image?query=natural%20organic%20beauty%20products%20eco-friendly%20packaging%2C%20clean%20beauty%20cosmetics%20sustainable%20lifestyle%2C%20plant-based%20products%20middle%20east&width=500&height=400&seq=bm_sust002&orientation=landscape"
                  alt="Eco-friendly beauty products at Blue Moon"
                  className="w-full h-full object-cover object-top"
                  loading="lazy"
                />
              </div>
              <div className="overflow-hidden flex-1">
                <img
                  src="https://readdy.ai/api/search-image?query=golden%20sunrise%20desert%20landscape%20oman%20nature%20sustainability%20environment%2C%20warm%20tones%2C%20beautiful%20arabian%20morning%2C%20environmental%20conservation&width=500&height=400&seq=bm_sust003&orientation=landscape"
                  alt="Sustainable beauty in Oman"
                  className="w-full h-full object-cover object-top"
                  loading="lazy"
                />
              </div>
            </div>
          </div>

          {/* Text */}
          <div>
            <p className="text-[#4a7fa5] text-xs tracking-[0.4em] uppercase mb-4 font-light">
              Our Commitment
            </p>
            <h2
              className="text-[#1a2744] text-3xl sm:text-4xl font-light tracking-wide mb-4 leading-tight"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              Sustainability
            </h2>
            <p
              className="text-[#1a2744]/60 text-base mb-4 text-right"
              style={{ fontFamily: "'Noto Naskh Arabic', serif" }}
            >
              التزامنا بالاستدامة في صالون القمر الأزرق
            </p>
            <p className="text-gray-500 text-sm leading-relaxed mb-8">
              At Blue Moon Beauty Salon in Al Koudh, Muscat, we take our responsibility
              to Oman&apos;s environment seriously. We constantly work to ensure our path
              to luxury beauty is also a path towards a sustainable future for our community.
            </p>
            <div className="space-y-5">
              {pillars.map((p) => (
                <div key={p.title} className="flex items-start gap-4">
                  <div className="w-10 h-10 flex items-center justify-center flex-shrink-0 border border-[#ece8e0]">
                    <i className={`${p.icon} text-[#c6a864] text-lg`}></i>
                  </div>
                  <div>
                    <h4 className="text-[#1a2744] text-sm font-medium mb-0.5">{p.title}</h4>
                    <p className="text-gray-400 text-xs mb-1" style={{ fontFamily: "'Noto Naskh Arabic', serif" }}>{p.titleAr}</p>
                    <p className="text-gray-400 text-sm leading-relaxed">{p.text}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
